import { connect } from 'react-redux'

const mapStateToProps = (state, hocProps) => ({
    endUsersData: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'endUsers',
        'data',
    ]),
    endUsersFilter: state.getIn([
        'ui',
        'workspace',
        'report',
        hocProps?.id,
        'blocks',
        'persons',
        'customData',
        'endUsers',
        'filter',
    ]),
})

export default connect(mapStateToProps, null)
